<!-- 官网首页 -->
<template>
  <div class="website_page">
    <div
      class="header_warp"
      :style="{backgroundImage: `url(${header_img})`,backgroundRepeat: 'no-repeat',backgroundSize: 'cover'}"
    ></div>
    <div class="nav_wrap">
      <div class="nav_left">
        <div
          class="nav_item"
          v-for="item of nav_left"
          :key="item.id"
          :style="{flex: `${item.flex}`,backgroundColor: `${item.bgcolor}`}"
        >
          <img
            :src="apiObj.VUE_APP_BASE_CDN + item.text_img"
            class="nav_text_img"
            @click="handleNavItem(item)"
            :style="{transform:`${item.style}`,top: `${item.top !== '0' ? item.top : 'null'}`,bottom: `${item.top == '0' ? '0' : null}`}"
          >
        </div>
      </div>
      <div class="nav_right">
        <div
          class="nav_item"
          v-for="item of nav_right"
          :key="item.id"
          :style="{flex: `${item.flex}`,backgroundColor: `${ item.bgcolor }`}"
        >
          <div
            v-if="item.bg_special"
            class="special_nav"
            :style="{backgroundImage: `url(${contact_bg})`,backgroundRepeat: 'no-repeat',backgroundSize: 'cover'}"
          >
            <img
              :src="apiObj.VUE_APP_BASE_CDN + item.text_img"
              class="nav_text_img special_nav_img"
              @click="handleNavItem(item)"
              :style="{transform:`${item.style}`,top: `${item.top !== '0' ? item.top : 'null'}`,bottom: `${item.top == '0' ? '0' : null}`}"
            >
          </div>
          <img
            v-else
            :src="apiObj.VUE_APP_BASE_CDN + item.text_img"
            class="nav_text_img"
            @click="handleNavItem(item)"
            :style="{transform:`${item.style}`,top: `${item.top !== '0' ? item.top : 'null'}`,bottom: `${item.top == '0' ? '0' : null}`}"
          >

          <div
            class="nav_more"
            v-if="item.is_more"
          >
            <img
              :src="apiObj.VUE_APP_BASE_CDN + nav_more.text_img"
              class="nav_text_img"
              @click="handleNavItem(nav_more)"
              :style="{transform:`${nav_more.style}`,top: `${nav_more.top !== '0' ? item.top : 'null'}`,bottom: `${nav_more.top == '0' ? '0' : null}`}"
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="footer_wrap"
      :style="{backgroundImage: `url(${footer_img})`,backgroundRepeat: 'no-repeat',backgroundSize: 'cover'}"
    ></div>
  </div>
</template>

<script>
import apiObj from '@a/js/api.js'
import { GetWxshareConfig } from '@a/js/api/public'
import { SetWechatShare } from '@a/js/utils'
import { Base64 } from 'js-base64'
import wx from 'weixin-js-sdk'
export default {
  name: 'Website',
  data() {
    return {
      apiObj,
      params: {
        accountid: "w17c10b758352313",
        projectid: "r17c10c112560247"
      },
      // header_img: require('@a/img/website/header.png'),
      // footer_img: require('@a/img/website/footer.png'),
      nav_left: [
        {
          id: 'l1',
          text: '展会介绍',
          flex: 1.4,
          bgcolor: '#27b5e7',
          style: 'translateX(-50%) translateY(-50%)',
          top: '50%',
          text_img: '/custom/2021/inspect/webnew/intro.png?v=' + this.$imgmark,
          link: 'https://c.banhuiyun.com/website/custom/w17c10b758352313/r17c10c112560247/f17c2162b4bf87cb'
        },
        {
          id: 'l2',
          text: '参展指南',
          flex: 1.1,
          bgcolor: '#c71279',
          style: 'translateX(-50%) translateY(-80%)',
          top: '50%',
          text_img: '/custom/2021/inspect/webnew/guide.png?v=' + this.$imgmark,
          link: 'https://c.banhuiyun.com/website/custom/w17c10b758352313/r17c10c112560247/y17c2163224cf04a'
        },
        {
          id: 'l3',
          text: '联系我们',
          flex: 1.2,
          bgcolor: '#16318a',
          style: 'translateX(-50%) translateY(-22.5%)',
          top: '0',
          text_img: '/custom/2021/inspect/webnew/contact.png?v=' + this.$imgmark,
          link: 'https://c.banhuiyun.com/website/custom/w17c10b758352313/r17c10c112560247/m17c21633f1ad7ca'
        },
      ],
      nav_right: [
        {
          id: 'r1',
          text: '展会动态',
          flex: 0.7,
          bgcolor: '#c71279',
          style: 'translateX(-50%) translateY(-50%)',
          top: '50%',
          text_img: '/custom/2021/inspect/webnew/news.png?v=' + this.$imgmark,
          link: 'https://c.banhuiyun.com/website/custom/w17c10b758352313/r17c10c112560247/c17c216302cb94eb'

        },
        {
          id: 'r2',
          text: '峰会议程',
          flex: 0.7,
          bgcolor: '#f8f7f5',
          style: 'translateX(-50%) translateY(-50%)',
          top: '50%',
          text_img: '/custom/2021/inspect/webnew/agenda.png?v=' + this.$imgmark,
          link: 'https://c.banhuiyun.com/website/custom/w17c10b758352313/r17c10c112560247/h17c2162dc86b482'
        },
        {
          id: 'r3',
          text: '观众注册',
          flex: 1.1,
          bgcolor: '#092f90',
          bg_special: true,
          style: 'translateX(-50%) translateY(-50%)',
          top: '50%',
          text_img: '/custom/2021/inspect/webnew/visitor.png?v=' + this.$imgmark,
          link: 'https://c.banhuiyun.com/form/form/w17c10b758352313/z17c10c0faffeeee'
        },
        {
          id: 'r4',
          text: '展商注册',
          flex: 0.6,
          bgcolor: '#c71279',
          is_more: true,
          style: 'translateX(-40%) translateY(-50%)',
          top: '50%',
          text_img: '/custom/2021/inspect/webnew/business.png?v=' + this.$imgmark,
          link: 'https://c.banhuiyun.com/form/form/w17c10b758352313/r17c10c112560247'
        },
        {
          id: 'r5',
          text: 'TIC大会报名',
          flex: 0.6,
          bgcolor: '#27b5e7',
          style: 'translateX(-50%) translateY(-50%)',
          top: '50%',
          text_img: '/custom/2021/inspect/webnew/tic.png?v=' + this.$imgmark,
          link: 'https://c.banhuiyun.com/form/form/w17c10b758352313/i17c30859939b81f'
        },
      ],
      nav_more: {
        id: 'nav_more',
        text: '更多服务',
        bgcolor: '#f7f6f4',
        style: 'translateX(-45%) translateY(-50%)',
        top: '50%',
        text_img: '/custom/2021/inspect/webnew/more.png?v=' + this.$imgmark,
        link: 'https://c.banhuiyun.com/website/custom/w17c10b758352313/r17c10c112560247/u17c2163616d07e8'
      }
    }
  },

  computed: {
    header_img() {
      return this.apiObj.VUE_APP_BASE_CDN + '/custom/2021/inspect/webnew/header.png?v=' + this.$imgmark
    },
    footer_img() {
      return this.apiObj.VUE_APP_BASE_CDN + '/custom/2021/inspect/webnew/footer.png?v=' + this.$imgmark
    },
    contact_bg() {
      return this.apiObj.VUE_APP_BASE_CDN + '/custom/2021/inspect/webnew/contact_bg.png?v=' + this.$imgmark
    }
  },

  components: {},

  methods: {
    // 点击导航
    handleNavItem(item) {
      // console.log(item.link)
      window.location.href = item.link
    },
    // 判断是否获取微信分享
    JudgeGetWxconfig() {
      if (window.location.host === 'c.banhuiyun.com') {
        this.InitGetWxShareConfig()
      }
    },
    // 页面初始化获取微信分享配置
    InitGetWxShareConfig() {
      let href = window.location.href.split('#')[0]
      let resdata = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        app_name: 'website',
        url: Base64.encode(href),
      }
      GetWxshareConfig(resdata)
        .then((res) => {
          // console.log(res)
          if (res.data.config.appId) {
            let imgUrl = ''
            if (res.data.info.img.length > 0) {
              imgUrl = apiObj.VUE_APP_BASE_CDN + res.data.info.img
            }
            SetWechatShare(wx, res.data, href, imgUrl)
          }
        })
        .catch(() => { })
    },
  },

  mounted() {
    this.JudgeGetWxconfig()
  }
}
</script>
<style lang="less" scoped>
.website_page {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow: hidden;
  .header_warp {
    width: 100%;
    // padding-bottom: 18.07%;
    padding-bottom: 18.13%;
  }
  .footer_wrap {
    width: 100%;
    background: #f7f6f4;
    // padding-bottom: 27.92%;
    padding-bottom: 27.94%;
  }
  .nav_wrap {
    flex: 1;
    display: flex;
    .nav_left {
      flex: 1;
      display: flex;
      flex-direction: column;
      background-color: #092f90;
    }
    .nav_right {
      // flex: 1.52;
      flex: 1.516;
      display: flex;
      flex-direction: column;
    }
    .nav_item {
      position: relative;
      .nav_body,
      .special_nav_body {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        // transform: translateX(-50%) translateY(-50%);
        text-align: center;
        .nav_name {
          font-size: 18px;
          letter-spacing: 0.05em;
        }
        .nav_name_en {
          margin-top: 3px;
          font-size: 12px;
        }
      }
      .special_nav_body,
      .special_nav_img {
        z-index: 9;
      }
      .nav_text_img {
        height: 32px;
        position: absolute;
        left: 50%;
      }
      .special_nav {
        width: 100%;
        height: 100%;
        background: #092f90;
        position: relative;
        overflow: hidden;
        .special_bg_wrap {
          position: absolute;
          z-index: 8;
          top: 0;
          left: -235px;
          // height: 100%;
          // // width: 490px;
          // width: 210%;
          height: 120%;
          width: 220%;
          background: #092f90;
          border-top-right-radius: 50%;
        }
      }
      .nav_more {
        position: absolute;
        z-index: 10;
        // width: 120%;
        // height: 186.3%;
        width: 110%;
        height: 157.3%;
        background: #f7f6f4;
        left: -90%;
        top: 50%;
        transform: translateY(-50%);
        border-top-right-radius: 55%;
        border-bottom-right-radius: 70%;
        border-bottom-left-radius: 32%;
        .nav_more_body {
          position: absolute;
          left: 51%;
          .nav_name {
            font-size: 18px;
            letter-spacing: 0.05em;
          }
          .nav_name_en {
            margin-top: 3px;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
